import { useEffect } from 'react'
import { useSharedValue, withSpring } from 'react-native-reanimated'
import { Control, FieldValues, Path, useController } from 'react-hook-form'
import { SelectButton } from '@ui/forms/Select/SelectButton'

import { WIDTH } from '../styles'
import { SelectedKey, SelectedKeySetter } from './types'

import { springConfig } from './styles'

interface Props<T extends FieldValues> {
  name: Path<T>
  control: Control<T>

  selected: SelectedKey<T>
  setSelected: SelectedKeySetter<T>
}

export default function PickerButton<T extends FieldValues>(props: Props<T>) {
  const { name, control, selected, setSelected } = props
  const isActive = selected === name ? 1 : 0
  const active = useSharedValue(isActive)

  const { field, fieldState } = useController({
    name,
    control,
  })

  useEffect(() => {
    active.set(withSpring(isActive, springConfig))
  }, [isActive])

  return (
    <SelectButton
      center
      active={active}
      errorMessage={fieldState.error?.message}
      style={{ width: WIDTH }}
      onPress={() => setSelected(name)}
      value={field.value}
      classNameTextInput="whitespace-nowrap p-0 w-full text-center"
    />
  )
}
